export default __webpack_public_path__ + "static/media/concierge-recipe-page-mobile.7b78c04a.svg";